import React from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { useAdminService } from '~/services';
import { moment, momentFormats } from '~/vendorConfigs/moment';

interface UnlockProps {
    user: UserType;
    setServerError: (e: { message: string }) => void;
}
export function Unlock({ user, setServerError }: UnlockProps) {
    const { updateUser } = useAdminService();
    const [loading, setLoading] = React.useState(false);
    const [sent, setSent] = React.useState(false);

    async function unlockUser() {
        try {
            setLoading(true);
            await updateUser(user.id, { is_locked: false }, { handledErrors: { 400: true } });
            setLoading(false);
            setSent(true);
        } catch (e) {
            setLoading(false);
            setServerError(e);
        }
    }

    if (sent) {
        return (
            <Alert variant="success">
                <div>User has been unlocked!</div>
            </Alert>
        );
    }

    return user.is_locked ? (
        <Alert variant="danger">
            <p>
                This user is currently locked. Their account will unlock automatically on{' '}
                {moment(user.unlocks_at).format(momentFormats.DATE_TEXT_AT_TIME)}.
            </p>
            <Alert.Link onClick={unlockUser}>Click here</Alert.Link>
            {loading && <Spinner animation="border" role="status" size="sm" className="ms-1" />} to
            unlock this user now.
        </Alert>
    ) : null;
}
